import type { DurationLike } from 'luxon';
import type { BillingOccurence } from '@/models/BillingOccurence';

export const CLICKFIRE_URL = 'https://clickfire.music2me.com';
// Use ISO 639-1 codes only
export const SUPPORTED_LOCALES = ['de', 'en', 'es'] as const;
export const CYBERWEEK_END_DATE = '2021-12-05T00:00:00+01:00';
export const CYBERWEEK_SWITCH_DATE = '2021-11-26T00:00:00+01:00';
export const PREFERRED_BILLING_OCCURENCE: BillingOccurence = 'Yearly';

export const ALLOWED_EXTERNAL_COOKIE_DOMAIN_PATTERN = ['.netlify.app'];

export const EMAIL_REMINDER_BEFORE_END_OF_TRIAL_DURATION: DurationLike = { days: 2 };
